import { CSSProperties, FC } from 'react'
import { cn } from '@/lib/utils'
import './styles.css'

interface ArrowProps {
	direction: 'left' | 'right'
	onClick: () => void
	style?: CSSProperties
	color?: 'white' | 'black'
	className?: string
}

export const NavigationArrow: FC<ArrowProps> = ({
	direction,
	onClick,
	style,
	color,
	className,
}) => {
	return (
		<button
			type='button'
			aria-label={direction === 'left' ? 'Назад' : 'Вперед'}
			onClick={onClick}
			className={cn(
				'navigation-arrow',
				direction === 'right' && 'navigation-arrow--right',
				color === 'white' && 'navigation-arrow--white',
				className
			)}
			style={style}>
			<svg
				width='26'
				height='26'
				viewBox='0 0 24 24'
				fill='none'
				aria-hidden='true'>
				<path
					d='M19 12H5M11 6l-6 6 6 6'
					stroke='currentColor'
					strokeWidth='2.35'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		</button>
	)
}
